<template>
  <div>
    <m-events-player
      v-if="showPlayer"
      :player-object="playerObject"
      :iscarousel="iscarousel"
      :autoplay="autoplay"
      :new-player-id="newPlayerId"
      :session-id="sessionId"
    />
    <figure
      v-else-if="thumbnail"
      class="image is-16by9"
    >
      <img v-lazy="thumbnail" />
    </figure>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MEventsPlayer from './MEventsPlayer.vue'

export default {
  name: 'PresentationMEventsPlayer',
  components: { MEventsPlayer },
  data() {
    return {
      presentationData: null,
      playerResource: null,
      initialized: false,
    }
  },
  props: {
    iscarousel: {
      type: Boolean,
      default: false,
    },
    thumbnail: {
      type: String,
      default: '',
    },
    resource: {
      type: Object,
      default: null,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    newPlayerId: {
      type: String,
      default: 'meventsPlayerElement',
    },
    sessionId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      configForKey: 'config/configForKey',
      getEventId: 'instancesState/getEventId',
      apiBaseUrl: 'instancesState/getApiBaseUrl',
      superUser: 'instancesState/getSuperUser',
      event: 'instancesState/getEvent',
    }),
    playerDefaults() {
      return this.configForKey('playerdefaults')
    },
    useVideoFilepath() {
      if (this.configForKey('app_config')?.configV2?.defaultV2 && 'useVideoFilepath' in this.configForKey('app_config').configV2.defaultV2) {
        return this.configForKey('app_config').configV2.defaultV2.useVideoFilepath
      }
      return false
    },
    showCOI() {
      const c = this.configForKey('app_config').configV2
      return 'showCOI' in c?.defaultV2
          ? c.defaultV2.showCOI
          : false
    },
    showCOIForSessions() {
      const c = this.configForKey('app_config').configV2
      return 'showCOIForSessions' in c?.defaultV2
          ? c.defaultV2.showCOIForSessions
          : []
    },
    showPlayer() {
      if (this.playerResource) {
        if (this.playerResource.sessionRecording) return true

        if (this.superUser) {
          return this.playerResource.is_uploaded
        }
        if (this.presentationData?.disableVMChecks) {
          return (
            this.presentationData.permissionForWebcast
            && !this.presentationData.suppressWebcast
            && this.playerResource.is_uploaded
          )
        }

        return (
          this.playerResource.is_approved
          && this.playerResource.is_handled
          && this.playerResource.is_uploaded
          && this.playerResource.is_published
        )
      }
      return false
    },
    playerObject() {
      let playerObject = {}
      
      if (this.playerResource.sessionRecordingV2) {
        playerObject.exporttype = 'autoFolder'
        playerObject.signed_url = '?jwt='+this.playerResource.signedUrl
        playerObject.baseurl = this.playerResource.baseurl
        playerObject.sessionRecording = this.playerResource.sessionRecording
        playerObject.id = this.playerResource.id
        if(this.newPlayerId) playerObject.pluginId = this.newPlayerId
        return playerObject
      }


      playerObject = this.playerDefaults
      playerObject.id = this.playerResource.id ? this.playerResource.id : null
      playerObject.sessionRecording = this.playerResource.sessionRecording
      playerObject.teaser = this.playerResource.teaser || null
      let baseUrl = this.playerResource.baseurl ? this.playerResource.baseurl : null
      let resourceTypeId = (this.playerResource.sessionRecording || !!this.playerResource.external_recording_url ) ? this.playerResource.resourcetype_id : null

      if (this.playerResource && this.playerResource.app_path && this.playerResource.path) {
        // eslint-disable-next-line max-len
        if (this.playerResource.resourcetype_id) {
          resourceTypeId = this.playerResource.resourcetype_id
        }
        if (resourceTypeId === 5 && (this.playerResource.prerecording_path == null || this.playerResource.prerecording_path == '')) {
          baseUrl = `https://d2t0unnjxes6lt.cloudfront.net/data/${this.playerResource.app_path}/data/talks/${this.playerResource.path}/`
        } else if (resourceTypeId === 4 || resourceTypeId === 3 || resourceTypeId === 2) {
          baseUrl = `https://d2t0unnjxes6lt.cloudfront.net/data/${this.playerResource.app_path}/data/eposters/${this.playerResource.path}/`
        }
        if(this.event === 'escrs2024'){
          baseUrl = `https://d2t0unnjxes6lt.cloudfront.net/data/${this.playerResource.app_path}/data/talks/${this.playerResource.path}/`
        }
        if(this.playerResource.special_settings){
          if (resourceTypeId === 5 && this.playerResource.prerecording_path !== null && this.playerResource.prerecording_path !== '' && this.playerResource.special_settings !== null &&  this.playerResource.special_settings?.prerecording_token !== null) {
            baseUrl = `https://d22xe8ytpnlz13.cloudfront.net/${this.playerResource.prerecording_path}?${this.playerResource.special_settings.prerecording_token}`
          
            playerObject.mediatype =  'video/mp4' 
          
          }
        }
       
      }


      if(this.playerResource.external_recording_url) {
          baseUrl = this.playerResource.external_recording_url
      }

      if (this.useVideoFilepath && this.playerResource && this.playerResource.app_path && this.playerResource.video_file_path) {
        // eslint-disable-next-line max-len
        if (this.playerResource.resourcetype_id) {
          resourceTypeId = this.playerResource.resourcetype_id
        }

        if (this.playerResource.video_file_path) {
          baseUrl = `https://assets.m-anage.com/${this.playerResource.video_file_path}/`
        }
      }

      if(this.playerResource?.path?.includes('https://')) {
        baseUrl = `${this.playerResource.path}/`

        playerObject.signed_url = '?jwt='+this.presentationData.signedUrl

      }

      playerObject.baseurl = baseUrl
      // playerObject.doi_file = baseUrl

      let mediaTypeId = null
      if (this.playerResource && this.playerResource.mediatype_id) {
        mediaTypeId = this.playerResource.mediatype_id
      }

      if (resourceTypeId === 5 ) {
        playerObject.exporttype = this.playerResource.sessionRecording || (!!this.playerResource.prerecording_path || !!this.playerResource.external_recording_url)  ? 'direct' : 'autoFolder'
        if (this.playerResource.sessionRecording || !!this.playerResource.external_recording_url) {
          playerObject.mediatype =  'video/mp4' 
          playerObject.crypted = 'true'
        } 

        playerObject.baseurl += this.playerResource.sessionRecording ? '' : ''
        playerObject.show_thumbs = true

      } else if (resourceTypeId === 4) {
        playerObject.exporttype = 'autoFolder'
      } else if (resourceTypeId === 3) {
        switch (mediaTypeId) {
          case 5:
            playerObject.exporttype = 'autoFolder'
            break
          default:
            playerObject.exporttype = 'autoFolder'
            break
        }
      } else if (resourceTypeId === 2) {
        playerObject.exporttype = 'autoFolder'
      } else if (resourceTypeId === 99) {
        playerObject.exporttype = 'stream'
        playerObject.mediatype = 'application/x-mpegURL'
        playerObject.baseurl = this.playerResource.path
      }


       if (this.showCOI && this.presentationData.containDoi &&  this.showCOIForSessions?.includes(this.presentationData.SessionId)) {
         playerObject.show_doi = '5'
         playerObject.doi_file = 'coi.png'
       }
      console.log(playerObject)
      return playerObject
    },
  },
  watch: {
  },
  methods: {
    ...mapActions({
      loadConfig: 'config/loadConfig',
    }),
  },
  async activated() {
    await this.loadConfig()
    this.playerResource = this.resource.playerResource
    this.presentationData = this.resource
    this.initialized = true
  },
   async mounted() {
    
    await this.loadConfig()
    this.playerResource = this.resource.playerResource
    this.presentationData = this.resource
    this.initialized = true
  },
}
</script>
